export const dashboardItems = [
  {
    title: 'Finance',    
    description: 'Upload and approve invoices. Reconcile and x-charge logistics They can be set to automatically be created in Xero and also update cost prices in the stock management system',
    route: '/',
    icon: 'mdi-file-document-outline',
    color: 'blue',
    children: [
      { title: 'Upload Invoices', component: 'UploadInvoices', route: '/upload-invoices', icon: 'mdi-file-upload', color: 'blue', description: 'Upload invoices from suppliers and automatically create in Xero' },
      { title: 'Invoice Management', component: 'InvoiceManagement', route: '/invoice-management', icon: 'mdi-file-document-multiple', color: 'blue', description: 'Manage invoices, update cost prices and automatically create in Xero' },
      { title: 'Wholesale Orders', component: 'WholesaleOrders', route: '/wholesale-orders', icon: 'mdi-point-of-sale', color: 'blue', description: 'Manage wholesale orders and automatically create in Xero' },
      { title: 'Cost Price Management', component: 'CostPriceManagement', route: '/cost-price-management', icon: 'mdi-currency-usd', color: 'blue', description: 'Manage product cost prices and sync with Veeqo' },
      { title: 'External POs (Veeqo)', component: 'ExternalPurchaseOrders', description: 'Download and send purchase orders synced from Veeqo', route: '/external-purchase-orders', icon: 'mdi-cart-outline', color: 'blue' },      
      { title: 'Purchase Orders', component: 'PurchaseOrders', description: 'Create and manage internal purchase orders with AI-powered import', route: '/purchase-orders', icon: 'mdi-cart-plus', color: 'blue' },      
      { title: 'Customer Sales Orders', component: 'CustomerSalesOrders', description: 'Create sales orders from customer POs and send to Veeqo/Xero', route: '/customer-sales-orders', icon: 'mdi-cart-arrow-right', color: 'blue' },      
      { title: 'Logistics Reconciliation', component: 'LogisticsReconciliation', route: '/logistics-reconciliation', icon: 'mdi-truck', color: 'blue', description: 'Reconcile shipping costs across entities and x-charge invoices in Xero' },
      { title: 'Cross-Company Reconciliation', component: 'CrossCompanyReconciliation', route: '/cross-company-reconciliation', icon: 'mdi-swap-horizontal-bold', color: 'blue', description: 'Reconcile cross-company orders and generate cross charges in Xero' },
      { title: 'Orders Explorer', component: 'VeeqoOrdersExplorer', route: '/orders-explorer', icon: 'mdi-package-variant', color: 'blue', description: 'Search, filter and export orders from Veeqo' }
    ]
  },
  {
    title: 'Bills of Materials',
    description: 'Manage bills of materials for manufacturing products. This includes the ability to create a new bill of material or update existing ones',
    route: '/',
    icon: 'mdi-clipboard-list-outline',
    color: 'green',
    children: [
      { title: 'BOM Management', component: 'BOM', route: '/bom', icon: 'mdi-clipboard-list-outline', color: 'green', description: 'Manage bills of materials for manufacturing products' },
      { title: 'Manufacturing', component: 'Manufacturing', route: '/manufacturing', icon: 'mdi-factory', color: 'green', description: 'Manage manufacturing orders. Create finished goods from raw materials' },
      { title: 'Manufacture Planning', component: 'ManufacturePlanning', route: '/manufacture-planning', icon: 'mdi-calendar-check', color: 'green', description: 'Recommendations with stock cover, sell-through, and suggested quantities' }
    ]
  },
  {
    title: 'Inventory',
    description: 'Manage stock takes and batch codes',
    route: '/',
    icon: 'mdi-package-variant-closed',
    color: 'orange',
    children: [
      { title: 'Stock Take', component: 'StockTakeManagement', route: '/stock-take', icon: 'mdi-scale-balance', color: 'orange', description: 'Manage stock takes for the warehouse' },
      { title: 'Stock Movement Report', component: 'StockMovementReports', route: '/stock-movement-reports', icon: 'mdi-transfer', color: 'orange', description: 'Track and analyze stock movements across locations' },
      { title: 'Packing List Generator', component: 'PackingListGenerator', route: '/packing-list-generator', icon: 'mdi-clipboard-text', color: 'orange', description: 'Generate packing lists for Veeqo orders' },
      { title: 'Bundle Management', component: 'BundleManagement', route: '/bundle-management', icon: 'mdi-package-variant-closed-plus', color: 'orange', description: 'Manage product bundles and calculate costs' },
      //{ title: 'Intercompany Transfer', component: 'IntercompanyTransfer', route: '/intercompany-transfer', icon: 'mdi-swap-horizontal', color: 'orange', description: 'Transfer inventory between company locations' },
      { title: 'Batch Codes', component: 'BatchCodes', route: '/batch-codes', icon: 'mdi-barcode', color: 'orange', description: 'Manage batch codes for stock control' },      
      { title: 'Inventory Snapshot', component: 'InventorySnapshot', route: '/inventory-snapshot', icon: 'mdi-chart-line', color: 'orange', description: 'View historical inventory snapshots' }
    ]
  },
  {
    title: 'Product Management',
    description: 'Manage products and categories',
    route: '/',
    icon: 'mdi-tag-multiple',
    color: 'purple',
    children: [
      { title: 'Data Cleanser', component: 'CleanseProducts', route: '/cleanse-products', icon: 'mdi-broom', color: 'purple', description: 'Cleanse and improve product data in bulk' },
      { title: 'Create Products', component: 'GenerateSKU', description: 'Generate standardised new products', route: '/sku-codes', icon: 'mdi-tag-outline', color: 'purple' },
      { title: 'PIF Management', component: 'PIFManagement', route: '/pif-management', icon: 'mdi-file-document-multiple', color: 'purple', description: 'Product Information Files for cosmetic and skincare products' },
    ]
  },
  {
    title: 'Clinic & Dispensary',
    description: 'Reports and dispensary management',
    route: '/',
    icon: 'mdi-stethoscope',
    color: 'red',
    children: [
      { title: 'Practitioner Management', component: 'PractitionerManagement', route: '/practitioner-management', icon: 'mdi-doctor', color: 'red', description: 'Manage practitioners and their commissions' },      
      { title: 'Dispensary Management', component: 'DispensaryManagement', route: '/dispensary-management', icon: 'mdi-pill', color: 'red', description: 'Manage dispensary stock and orders' },
      { title: 'Manufacturing Planning', component: 'ManufacturingPlanning', route: '/manufacturing-planning', icon: 'mdi-calendar-check', color: 'red', description: 'Plan daily dispensary manufacturing based on orders' },
      { title: 'Prescriptions & Dispensary Orders', component: 'PrescriptionManagement', route: '/prescription-management', icon: 'mdi-prescription', color: 'red', description: 'Manage dispensary orders and prescriptions' }
    ]
  }, 
  {
    title: 'AI Insights',   
    component: 'AIInsights',
    description: 'Generate insights for stock, ordering and pricing with AI insights',
    route: '/ai-insights',
    icon: 'mdi-robot-outline',
    color: 'pink',
    children: [
      { title: 'Faire Analytics', component: 'FaireReports', route: '/faire-reports', icon: 'mdi-chart-line', color: 'pink', description: 'Comprehensive analytics and reporting for Faire orders, products, and customers' },
      { title: 'Top Products Report', component: 'TopProductsReport', route: '/top-products-report', icon: 'mdi-trophy', color: 'pink', description: 'Analyze top-performing products by sales and profit across entities and channels' },
      { title: 'Slow Moving Products', component: 'SlowMovingProductsReport', route: '/slow-moving-products', icon: 'mdi-turtle', color: 'orange', description: 'Identify slow-moving inventory and optimize stock levels' }
    ]
  },
  
  {
    title: 'Store Agents',   
    component: 'StoreAgents',
    description: 'AI-powered agents to help manage your Shopify stores',
    route: '/store-agents',
    icon: 'mdi-robot-excited',
    color: 'cyan'
  },
  {
    title: 'Configuration',    
    description: 'System configuration and settings',
    route: '/',
    icon: 'mdi-cog',
    color: 'grey',
    children: [
      { title: 'General Settings', component: 'Config', route: '/config', icon: 'mdi-cog', color: 'grey', description: 'System configuration and settings' },
      { title: 'AI Assitants', component: 'AIConfig', route: '/ai-config', icon: 'mdi-robot-industrial', color: 'grey', description: 'AI Assistants configuration' },
      { title: 'Skills', component: 'Skills', route: '/skills', icon: 'mdi-robot-outline', color: 'grey', description: 'Manage AI skills' },
      { title: 'User Management', component: 'UserManagement', route: '/user-management', icon: 'mdi-account-cog', color: 'grey', description: 'Manage users and permissions' },
      { title: 'Integrations', component: 'Integrations',  route: '/settings/integrations', icon: 'mdi-connection', color: 'grey', description: 'Manage third-party integrations like Xero and Veeqo'  }
    ]
  },
  
];

export const navigationItems = [
  {
    title: 'Dashboard',
    icon: 'mdi-view-dashboard',
    route: '/',
    color: 'primary'
  },
  ...dashboardItems,
  { title: 'Logout', icon: 'mdi-logout', route: null },
];

